export function isPendingKundennummer(kn: string | null | undefined): boolean {
  return !!kn && kn.startsWith('pending-')
}

export const KUNDENNUMMER_PENDING_TEXT = "Wird bei AVGS-Upload eingelesen"
